import { createContext, useContext } from "react";
import type { ClientAdvance } from "features/ClientAdvances/types/client-advance.types";

interface ClientAdvanceOverviewContextType {
  advance: ClientAdvance | null;
  refetch: () => Promise<void>;
}

const ClientAdvanceOverviewContext =
  createContext<ClientAdvanceOverviewContextType | null>(null);

export const useClientAdvanceOverview = () => {
  const context = useContext(ClientAdvanceOverviewContext);
  if (!context) {
    throw new Error("useClientAdvanceOverview must be used within provider");
  }
  return context;
};

export default ClientAdvanceOverviewContext;
